import { batch } from 'react-redux';

import { requestSlots } from '@r1-frontend/service-engineer-visit/actions';
import { initialized, setDeliveryOptions } from '@r1-frontend/service-engineer-visit/actions/simple';
import { TContextDispatch } from '@r1-frontend/service-engineer-visit/context/Context';
import { ESaleAgentClientName } from '@r1-frontend/service-engineer-visit/types/ESaleAgentClientName';
import { TDeliveryOption } from '@r1-frontend/service-engineer-visit/types/TDeliveryOption';
import { TGetTimeSlots } from '@r1-frontend/service-engineer-visit/types/TGetTimeSlots';

import selectDeliveryOption from './selectDeliveryOption';

export type TInitializationProps = {
    getTimeSlotsFunc: TGetTimeSlots,
    contractId: number,
    clientName: ESaleAgentClientName,
    gaCategory: string,
    gaLabel?: string,
    productId?: number,
    dateFrom?: Date,
    numberOfDays?: number,
    maxNumberOfDays?: number,
    deliveryOptions?: TDeliveryOption[],
    selectedDeliveryOption?: TDeliveryOption,
    withComment?: boolean,
};

const initialization = (
    {
        getTimeSlotsFunc,
        dateFrom = new Date(),
        numberOfDays = 7,
        maxNumberOfDays = 30,
        contractId,
        productId = undefined,
        clientName,
        deliveryOptions,
        selectedDeliveryOption = undefined,
        withComment = false,
        gaCategory,
        gaLabel,
    }: TInitializationProps,
    domain: string,
) => (dispatch: TContextDispatch) => {
    dispatch(initialized({
        dateFrom,
        numberOfDays,
        maxNumberOfDays,
        contractId,
        clientName,
        productId,
        withComment,
        gaCategory,
        gaLabel,
    }));

    // if usage of container with the delivery options then will be dispatched the select delivery option with inner call the request slots action.
    // otherwise we should call it manually
    if (deliveryOptions) {
        batch(() => {
            dispatch(setDeliveryOptions(deliveryOptions));
            // @ts-ignore
            dispatch(selectDeliveryOption(selectedDeliveryOption ? selectedDeliveryOption : deliveryOptions[0], domain, productId, gaLabel));
        });
    } else {
        // @ts-ignore
        dispatch(requestSlots(productId, getTimeSlotsFunc, gaLabel));
    }
};

export default initialization;

